<div class="tråd-kontainer" (click)="fokuserSvarfelt()">

  <div class="kommentar initiator e2e-kommentar">
    <div class="meny">
      @if (erForfatter()) {
        <button mat-icon-button [matMenuTriggerFor]="traadMeny" (click)="$event.stopPropagation()" class="mat-medium-icon-button e2e-meny">
          <mat-icon class="material-symbols-fet">more_vert</mat-icon>
        </button>
        <mat-menu #traadMeny="matMenu">
          @if (traad().privat) {
            <button mat-menu-item (click)="gjoerPrivat(false)">
              <mat-icon fontSet="lederplan-ikon-eye-outline" class="mat-icon--lederplan-ikon"/> {{ "Gjør synlig for alle" | translate }}
            </button>
          } @else {
            <button mat-menu-item (click)="gjoerPrivat(true)" [disabled]="!kanEndreTilPrivat()" matTooltip="{{endreTilPrivatTooltip()}}">
              <mat-icon fontSet="lederplan-ikon-eye-off-outline" class="mat-icon--lederplan-ikon"/> {{ "Gjør privat" | translate }}
            </button>
          }
          <button mat-menu-item [bekreftKlikk]="'Ja, slett denne tråden'|translate" (klikk)="slettTraad()">
            <mat-icon fontSet="ion-ios-trash" class="mat-icon--ionic-ikon"/> {{ "Slett" | translate }}
          </button>
        </mat-menu>
      }
    </div>
    <div class="forfatter">
      <avatar [medlem]="traad().publisertAv" stil="liten" class="e2e-forfatter"/>
      <span class="informerte">
        <i class="std-ikon ion-ios-arrow-thin-right"></i>
        @for(medlem of varsledeEksTraadForfatter(); track medlem.id){
          <avatar [medlem]="medlem" stil="mini" class="e2e-varslet"/>
        }
        @if(traad().varslede.length > 3){
          <span class="antall-informerte">+{{traad().varslede.length-3}}</span>
        }
      </span>
    </div>
    <div class="melding">
      <div class="tekst e2e-kommentartekst" [innerHTML]="traad().kommentar | linky"></div>
      <div class="dato">
        {{ traad().publisertDato | zoneddatetime_relativ | async }}
        @if (traad().privat) {
          <span class="privat" matTooltip="{{'Denne kommentaren er privat og dermed kun synlig for deg'|translate}}">
            (<i class="lederplan-ikon lederplan-ikon-eye-off-outline"></i> {{ 'Privat'|translate }})
          </span>
        }
      </div>
    </div>
    <div class="forfatter"></div>
    <div class="menymeny"></div>
  </div>

  @for(svar of traad().svar; track svar.id){
    <div class="kommentar svar e2e-svar" [ngClass]="{'initiator':svar.publisertAv.id == traad().publisertAv.id}">
      <div class="meny">
        @if(svar.publisertAv.id == traad().publisertAv.id){
          <ng-container *ngTemplateOutlet="svarMeny; context: {svar: svar}"/>
        }
      </div>
      <div class="forfatter">
        @if(svar.publisertAv.id == traad().publisertAv.id){
          <avatar [medlem]="svar.publisertAv" stil="liten" class="e2e-forfatter"/>
        }
      </div>
      <div class="melding">
        <div class="tekst e2e-melding" [innerHTML]="svar.svar | linky"></div>
        <div class="dato">{{svar.publisertDato | zoneddatetime_relativ | async}}
        </div>
      </div>
      <div class="forfatter">
        @if(svar.publisertAv.id != traad().publisertAv.id){
          <avatar [medlem]="svar.publisertAv" stil="liten" class="e2e-forfatter"/>
        }
      </div>
      <div class="meny">
        @if(svar.publisertAv.id != traad().publisertAv.id){
          <ng-container *ngTemplateOutlet="svarMeny; context: {svar: svar}"/>
        }
      </div>
    </div>
  }

  @if(!traad().privat){
    <nytt-kommentar-svar [traadId]="traad().id" />
  }

</div>

<!--handlinger-meny for svar -->
<ng-template #svarMeny let-svar="svar">
  @if(kanSletteSvar(svar)){
    <button mat-icon-button [matMenuTriggerFor]="svarMeny" (click)="$event.stopPropagation()" class="mat-medium-icon-button e2e-meny">
      <mat-icon class="material-symbols-fet">more_vert</mat-icon>
    </button>
    <mat-menu #svarMeny="matMenu">
      <button mat-menu-item [bekreftKlikk]="'Ja, slett denne kommentaren'|translate" (klikk)="slettSvar(svar)">
        <mat-icon fontSet="ion-ios-trash" class="mat-icon--ionic-ikon"/> {{ "Slett" | translate }}
      </button>
    </mat-menu>
  }
</ng-template>
